import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';
/**
 * Slim scroll-progress bar fixed bovenaan de pagina.
 * Smoothed met een spring zodat hij niet jittery aanvoelt.
 */
export function ScrollProgress() {
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 25,
    restDelta: 0.001
  });
  return <motion.div className="fixed top-0 left-0 right-0 z-[60] h-[3px] origin-left bg-gradient-to-r from-orange-500 via-amber-500 to-rose-500" style={{
    scaleX
  }} data-id="element-695" />;
}